module.exports = __webpack_public_path__ + "static/media/collection-feather.31dc6b63.png";